import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['paymentintervals'])
export default class PaymentIntervals extends Component {

  constructor(props) {
    super(props)

    this.props.paymentintervals.loadAllPaymentIntervals()
  }

  newPaymentInterval(row) {
    this.props.paymentintervals.newPaymentInterval(row.name)
  }

  updatePaymentInterval(row, cellText, cellValue) {
    this.props.paymentintervals.updatePaymentInterval(row.id, cellValue)
  }

  deletePaymentInterval(id) {
    if (confirm('Are you sure you want to delete this Payment Interval?')) {
      this.props.paymentintervals.deletePaymentInterval(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deletePaymentInterval(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newPaymentInterval.bind(this)
    }

    const paymentIntervalsTable = (
      <BootstrapTable
          data={ this.props.paymentintervals.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updatePaymentInterval.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Payment Intervals" content={ paymentIntervalsTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/paymentintervals.js